import styled from "styled-components";
import * as PropTypes from "prop-types";

export default function Icon({
  src,
  className,
  style,
  disableMinW,
  disableMinH,
  onClick,
}) {
  return (
    <Wrapper className={className} style={style} onClick={onClick || noop}>
      <ImgContainer
        src={src}
        disableMinW={disableMinW}
        disableMinH={disableMinH}
      />
    </Wrapper>
  );
}

function noop() {}

Icon.propTypes = {
  src: PropTypes.any.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  disableMinW: PropTypes.bool,
  disableMinH: PropTypes.bool,
  onClick: PropTypes.func,
};

Icon.defaultProps = {
  className: "",
  style: {},
  disableMinW: false,
  disableMinH: false,
};

const Wrapper = styled.div`
  height: inherit;
  width: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ImgContainer = styled.img`
  ${({ disableMinW }) => !disableMinW && "min-width: 1rem;"};
  ${({ disableMinH }) => !disableMinH && "min-height: 1rem;"};
`;
